

































import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "CreatePostMinimizedView",
  components: { BaseSpinner, BaseButton, BaseIcon },
  props: {
    errorUploadingFile: { type: Boolean, default: false },
    isPublished: { type: Boolean, default: false },
    // processing status of the saved post: the post goes live only when it is "OK"
    processingStatus: { type: String, default: "OK" },
    uploadedFilesNumber: { type: Number, default: 0 },
    totalFiles: { type: Number, required: true },
  },
});
